/**
 * 优先从 window.performance 获取设备参数；
 * 某些旧运行时如果仍挂在 performanceTracker 上，则继续兼容兜底。
 */
export const getDeviceParamsFromTracker = (): Record<string, string> => {
    try {
        const performanceDeviceParams = (window as any).performance?.getDeviceParams?.();

        if (
            performanceDeviceParams &&
            typeof performanceDeviceParams === 'object'
        ) {
            return performanceDeviceParams as Record<string, string>;
        }

        const trackerDeviceParams =
            (window as any).performanceTracker?.getDeviceParams?.();

        if (trackerDeviceParams && typeof trackerDeviceParams === 'object') {
            return trackerDeviceParams as Record<string, string>;
        }

        return {};
    } catch {
        return {};
    }
};
